module.exports = require('./helpers/bundle-url').getBundleURL('5C5nw') + "logo.c51670a8.svg";